<template>
  <b-skeleton-wrapper :loading="!loaded">
    <template #loading>
      <b-row>
        <b-skeleton width="100%" height="427px" />
      </b-row>
    </template>
    <div class="mc-dashboard__widget-item mc-dashboard__widget-driverviolations">
      <h5 class="mc-dashboard__widget-title">
        {{ $t('dashboard.title.driverViolationTotal') }}
        <i id="tootltipViolations" class="mc-fa icon-outline_info"></i>
        <b-tooltip target="tootltipViolations" triggers="hover" placement="topleft">
          {{ $t('dashboard.summary.tooltip.driverViolationTotal') }}
        </b-tooltip>
      </h5>
      <b-row>
        <b-col md="6">
          <div class="mc-dashboard__widget-driverviolations-item">
            <div v-if="render" class="mc-chart mc-chart--pie">
              <PieChart :key="pieChartKey" :labels="getChartLabel" :datasets="getChartDataset" />
            </div>
          </div>
        </b-col>
        <b-col md="6">
          <div class="mc-dashboard__widget-driverviolations-item">
            <div class="d-flex justify-content-between">
              <div>
                <span>{{ $t('dashboard.title.violationTotal') }}</span>
                <h4>
                  {{ datas ? thousandFormat(datas.driverViolation.summary.chosenValue) : 0 }}
                  {{ $t('global.times') }}
                </h4>
              </div>
              <div>
                <McBadge
                  :text="
                    lang === 'id'
                      ? `${
                          datas && datas.driverViolation.summary.increased
                            ? $t('maintenance.lots')
                            : $t('maintenance.little')
                        } ${datas ? datas.driverViolation.summary.diffPercent : 0}% ${$t(
                          'maintenance.fromLastMonth'
                        )}`
                      : `${datas ? datas.driverViolation.summary.diffPercent : 0}% ${
                          datas && datas.driverViolation.summary.increased
                            ? $t('maintenance.lots')
                            : $t('maintenance.little')
                        } ${$t('maintenance.fromLastMonth')}`
                  "
                  :variant="
                    datas && datas.driverViolation.summary.increased
                      ? 'outlineDanger'
                      : 'outlineSuccess'
                  "
                  size="medium"
                  type="button"
                  class="d-block mt-3"
                />
              </div>
            </div>
            <div class="border border-1">
              <table class="table b-table table-sm">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>{{ $t('global.object.violation') }}</th>
                    <th>{{ $t('global.text.total') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>{{ $t('dashboard.label.overspeed') }}</td>
                    <td>{{ datas ? datas.driverViolation.data.overSpeed.chosenValue : 0 }}</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>{{ $t('dashboard.label.harshAccel') }}</td>
                    <td>{{ datas ? datas.driverViolation.data.harshAccel.chosenValue : 0 }}</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>{{ $t('dashboard.label.fuelAnomaly') }}</td>
                    <td>{{ datas ? datas.driverViolation.data.fuelAnomaly.chosenValue : 0 }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </b-skeleton-wrapper>
</template>
<script>
import PieChart from '@/components/Chart/Pie'
import McBadge from '@/components/McBadge'
import { Helper } from '@/mixin/helper'
import i18n from '../../../../../i18n'

export default {
  components: {
    PieChart,
    McBadge,
  },
  mixins: [Helper],
  props: {
    datas: {
      type: Object,
      default: () => null,
    },
    loaded: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isLayoutEdit: false,
      loading: true,

      pieChartKey: 0,
      refresh: false,
      render: true,

      lang: i18n.locale,
    }
  },
  computed: {
    getChartDataset() {
      const dataFromApi = this.datas
        ? [
            this.datas.driverViolation.data.overSpeed.chosenValue,
            this.datas.driverViolation.data.harshAccel.chosenValue,
            this.datas.driverViolation.data.fuelAnomaly.chosenValue,
          ]
        : [0, 0, 0]
      return [
        {
          data: dataFromApi,
          label: '',
          backgroundColor: ['#f41d00', '#ff8a00', '#8f49de'],
        },
      ]
    },
    getChartLabel() {
      return [
        this.$t('dashboard.label.overspeed'),
        this.$t('dashboard.label.harshAccel'),
        this.$t('dashboard.label.fuelAnomaly'),
      ]
    },

    totalChartData() {
      return {
        violation: {
          labels: [
            this.$t('dashboard.label.overspeed'),
            this.$t('dashboard.label.harshAccel'),
            this.$t('dashboard.label.fuelAnomaly'),
          ],
          datasets: [
            {
              data: [25, 45, 30],
              label: '',
              backgroundColor: ['#f41d00', '#ff8a00', '#8f49de'],
            },
          ],
        },
      }
    },
  },
  watch: {
    datas: {
      handler() {
        this.pieChartKey += 1
      },
      deep: true,
    },
    'i18n.locale': {
      handler() {
        this.render = false

        setTimeout(() => {
          this.render = true
        }, 500)
      },
    },
  },
}
</script>
